const useMemoizePromise = <T>() => {
  let argsString: string | null = null
  let promise: Promise<T> | null = null

  const memoize = async <Args extends unknown[]>(fn: (...args: Args) => Promise<T>, ...args: Args): Promise<T> => {
    if (argsString !== JSON.stringify(args)) {
      reset()
    }
    if (promise === null) {
      promise = fn(...args)
      argsString = JSON.stringify(args)
    }
    try {
      return await promise
    } catch (error: unknown) {
      reset()
      throw error
    }
  }

  const reset = () => {
    promise = null
    argsString = null
  }

  return { memoize, reset }
}

export default useMemoizePromise
